import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  error: null,
  // Compat aggregate only. Route UI must not treat this as the loading
  // signal for a single cache key — overlapping fetches can keep this true
  // while one entry is already settled, or clear it while another is in flight.
  isFetching: false,
  content: {},
}

// Keep manager.isFetching as OR of per-entry flags for legacy readers.
// Prefer content[key].isFetching (via selectCurriculumContent.loading).
const syncGlobalFetching = state => {
  state.isFetching = Object.values(state.content).some(
    entry => entry?.isFetching === true,
  )
}

const reducers = {
  fetchingContent: (state, { payload }) => {
    const { contentStateKey } = payload
    state.error = null
    if (!state.content[contentStateKey]) {
      state.content[contentStateKey] = {}
    }
    state.content[contentStateKey].isFetching = true
    state.content[contentStateKey].error = null
    syncGlobalFetching(state)
  },

  fetchContentError: (state, { payload }) => {
    const { contentStateKey, error } = payload
    if (!state.content[contentStateKey]) {
      state.content[contentStateKey] = {}
    }
    state.content[contentStateKey].isFetching = false
    state.content[contentStateKey].error = error
    state.error = error
    syncGlobalFetching(state)
  },

  fetchContentSuccess: (state, { payload }) => {
    const { contentStateKey, data } = payload
    state.error = null
    state.content[contentStateKey] = { data, isFetching: false }
    syncGlobalFetching(state)
  },

  clearErrors: state => {
    state.error = null
  },
}

const slice = createSlice({
  initialState,
  name: 'curriculumContent',
  reducers,
})

export const actions = slice.actions
export default slice.reducer
